import React, {Component} from 'react';

import {IUsageResultGrade} from "../../models/usage-analytics/IUsageResult";
import {IUsageArea} from "../../models/usage-analytics/ISchoolUsageSummary";
import IAreaUsageSummary from '../../models/usage-analytics/IAreaUsageSummary';
import DoughnutCard, { DoughnutData } from '../DoughnutCard';
import LoadingCard from '../LoadingCard';
import { gradeToPieChartColour } from './GradeColourConverter';

interface AreaUsageSummaryChartsProps {
    areaUsageSummary?: IAreaUsageSummary;
}

interface AreaUsageSummaryChartsState {
}


export class AreaUsageSummaryCharts extends Component<AreaUsageSummaryChartsProps, AreaUsageSummaryChartsState> {
    static displayName = AreaUsageSummaryCharts.name;

    constructor(props: AreaUsageSummaryChartsProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {

    }

    componentDidUpdate(prevProps: Readonly<AreaUsageSummaryChartsProps>, prevState: Readonly<AreaUsageSummaryChartsState>, snapshot?: any): void {

    }

    getChartData(usageArea: IUsageArea) {
        var data: DoughnutData[] = [];

        Object.keys(this.props.areaUsageSummary!.data[usageArea]).forEach(grade => {
            data.push({
                label: grade,
                value: this.props.areaUsageSummary!.data[usageArea][grade as IUsageResultGrade],
                colour: gradeToPieChartColour(grade as IUsageResultGrade)
            })
        })

        return data;
    }

    render(): JSX.Element {

        if (this.props.areaUsageSummary?.data === undefined) {

            return <LoadingCard text={"Loading..."} />;
        }

        return (
            <div className="area-usage-summary-charts-card">
                <div className="card__header">
                    <span className="card__title">
                        Area usage
                    </span>
                </div>

                <div className="area-usage-summary-charts-card__chart-container">
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Subject Usage"} data={this.getChartData(IUsageArea.subject)}/>
                    </div>
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Assignment Usage"} data={this.getChartData(IUsageArea.assignment)}/>
                    </div>
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Notebook Usage"} data={this.getChartData(IUsageArea.notebook)}/>
                    </div>
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Student Folder Usage"} data={this.getChartData(IUsageArea.studentFolders)}/>
                    </div>
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Home Site Usage"} data={this.getChartData(IUsageArea.homeSite)}/>
                    </div>
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Staff Site Usage"} data={this.getChartData(IUsageArea.staffSite)}/>
                    </div>
                    <div className="area-usage-summary-chart">
                        <DoughnutCard title={"Training Site Usage"} data={this.getChartData(IUsageArea.trainingSite)}/>
                    </div>
                </div>
            </div>
        );
    }
}